export default __webpack_public_path__ + "static/media/KOD0093-min.e265e3ea.webp";